/* any functionality that's shared between component variants but not needed by external components goes in this file */
import React from 'react';
import { LoadingIcon } from '@chegg-ui/theme';
import { ButtonContent, ButtonContentWrapper, LoadingText, VisuallyHidden } from './styles';
export var ButtonLabel = function ButtonLabel(_ref) {
  var children = _ref.children,
      isLoading = _ref.isLoading,
      size = _ref.size,
      loadingText = _ref.loadingText;
  return /*#__PURE__*/React.createElement(ButtonContentWrapper, null, /*#__PURE__*/React.createElement(ButtonContent, {
    isVisible: !isLoading,
    size: size,
    "aria-hidden": isLoading
  }, children), size !== 'xsmall' && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(ButtonContent, {
    isVisible: isLoading,
    size: size,
    "aria-hidden": !isLoading
  }, loadingText ? /*#__PURE__*/React.createElement(LoadingText, null, loadingText) : /*#__PURE__*/React.createElement(VisuallyHidden, null, children), /*#__PURE__*/React.createElement(LoadingIcon, {
    size: 'medium',
    svgColor: 'currentColor',
    viewBox: "0 -3 32 32"
  })), /*#__PURE__*/React.createElement("span", {
    "aria-live": "polite",
    "data-test": "button-loading-status",
    hidden: true,
    role: "status"
  }, isLoading ? null : /*#__PURE__*/React.createElement(React.Fragment, null, children, " done loading"))));
};